export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#132A20] text-[#F7F5F0] py-12 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div>
            <span className="inline-flex items-center justify-center bg-[#F7F5F0] rounded-xl p-2.5 shadow-[0_2px_10px_rgba(0,0,0,0.2)]">
              <img
                src="/svea-logo.png?v=3"
                alt="Svea Ytservice AB logotyp"
                className="h-16 w-auto block"
                loading="lazy"
                decoding="async"
              />
            </span>
            <p className="mt-5 text-[#F7F5F0]/65 text-sm leading-relaxed max-w-xs">
              Skonsam ytservice för tak och fasad. Noggrant hantverk och tydlig
              återkoppling.
            </p>
          </div>
          <div className="text-sm">
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#F7F5F0]/55">
              Företag
            </div>
            <div className="mt-3 text-[#F7F5F0]/85">Svea Ytservice AB</div>
            <div
              data-testid="footer-orgnr"
              className="mt-1 text-[#F7F5F0]/65"
            >
              Org.nr 559586-3035
            </div>
          </div>
          <div className="text-sm">
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#F7F5F0]/55">
              Kontakt
            </div>
            <a
              data-testid="footer-email"
              href="mailto:info@sveaytservice.se"
              className="mt-3 inline-block text-[#F7F5F0]/85 hover:text-[#F7F5F0] underline-offset-4 hover:underline"
            >
              info@sveaytservice.se
            </a>
            <a
              data-testid="footer-phone"
              href="tel:+46738741447"
              className="mt-1 block text-[#F7F5F0]/85 hover:text-[#F7F5F0] underline-offset-4 hover:underline"
            >
              073-874 14 47
            </a>
            <div className="mt-4 flex gap-5 text-xs text-[#F7F5F0]/55">
              <a href="#tjanster" className="hover:text-[#F7F5F0]">Tjänster</a>
              <a href="#process" className="hover:text-[#F7F5F0]">Process</a>
              <a href="#kontakt" className="hover:text-[#F7F5F0]">Kontakt</a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-[#F7F5F0]/10 flex flex-col gap-3">
          <p className="text-xs text-[#F7F5F0]/55 max-w-2xl leading-relaxed">
            När du skickar formuläret behandlas dina uppgifter endast för att
            kunna besvara din förfrågan.
          </p>
          <div className="flex flex-col md:flex-row gap-2 md:gap-6 justify-between text-xs text-[#F7F5F0]/45">
            <div>© {year} Svea Ytservice AB. Alla rättigheter förbehållna.</div>
            <div>Skonsam ytservice för tak och fasad.</div>
          </div>
          <div
            data-testid="footer-credit"
            className="mt-4 text-[11px] text-[#F7F5F0]/35 tracking-wide"
          >
            Hemsida skapad av{" "}
            <a
              href="https://elido.nu"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-credit-link"
              className="text-[#F7F5F0]/55 hover:text-[#F7F5F0] underline-offset-4 hover:underline transition-colors"
            >
              Elido
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
